export {};

const config = {
    api: {
        url: "http://localhost:3000",
    }
};

export default config; 